module.exports = __webpack_public_path__ + "img/it-IT-add-to-google-wallet.e411485.svg";